import routes from './routes/appointment.routes';
import ModuleBase from '../../classes/ModuleBase';

export default new ModuleBase({
    name: 'Appointment',
    routes: routes
});